module.exports = __webpack_public_path__ + "img/ZTOBUHaveOrder_05.53b81484.jpg";